import { useEffect, useState } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { createOptions, getOptions } from '../../../redux/features/options/optionService';
import { showToast } from '../../../components/ToastMsg';
import BeatLoader from 'react-spinners/BeatLoader';
import GridLoader from 'react-spinners/GridLoader';

const Options = () => {
    const dispatch = useDispatch();

    const { isLoading } = useSelector((state) => state.option.options);
    const { isOptionsCreating } = useSelector((state) => state.option.newOptions);

    const [data, setData] = useState({
        min_withdrawal_amount: '',
        max_withdrawal_amount: '',
        min_deposit_amount: '',
        max_deposit_amount: '',
        max_auto_add_win_amount: '',
        status: '',
    });

    const [isTrue, setTrue] = useState(false);

    useEffect(() => {
        dispatch(getOptions())
            .unwrap()
            .then((res) => {
                setData((prev) => ({
                    ...prev,
                    min_withdrawal_amount: res[0]?.min_withdrawal_amount || '',
                    max_withdrawal_amount: res[0]?.max_withdrawal_amount || '',
                    min_deposit_amount: res[0]?.min_deposit_amount || '',
                    max_deposit_amount: res[0]?.max_deposit_amount || '',
                    max_auto_add_win_amount: res[0]?.max_auto_add_win_amount || '',
                    status: res[0]?.status || '',
                }));
                setTrue(res[0]?.status);
            })
            .catch((err) => showToast('error', err.message));
    }, [dispatch]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleToggle = () => {
        setTrue((prev) => !prev);
    };

    const insertOptions = async () => {
        try {
            data.status = isTrue;
            const filteredData = Object.fromEntries(
                Object.entries(data)
                    .filter(([key, value]) => value !== "" && value !== undefined)
                    .map(([key, value]) => {
                        if (key === "status") return [key, Boolean(value)];
                        return [key, isNaN(value) ? value : Number(value)];
                    })
            );
            const response = await dispatch(createOptions(filteredData)).unwrap();
            if (response.success === true) {
                showToast('success', response.option);
                dispatch(getOptions())
                    .unwrap()
                    .then((res) => {
                        setData((prev) => ({
                            ...prev,
                            min_withdrawal_amount: res[0]?.min_withdrawal_amount || '',
                            max_withdrawal_amount: res[0]?.max_withdrawal_amount || '',
                            min_deposit_amount: res[0]?.min_deposit_amount || '',
                            max_deposit_amount: res[0]?.max_deposit_amount || '',
                            max_auto_add_win_amount: res[0]?.max_auto_add_win_amount || '',
                            status: res[0]?.status || '',
                        }));
                        setTrue(res[0]?.status);
                    })
                    .catch((err) => showToast('error', err.message));
            }
        }
        catch (error) {
            showToast('error', error.message);
        };
    };

    return (
        <>
            <div className={`main-card`}>
                <div className={`main-card-body`}>
                    <h1 className={`form-title ${styles.headDiv}`}>
                        Options
                    </h1>
                </div>
                {isLoading ?
                    <div className={`loader-style`}>
                        <GridLoader color="#1D0C50" />
                    </div>
                    :
                    <>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col  md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Min Withdrawal Amount
                                    </label>
                                    <input
                                        type="text"
                                        name='min_withdrawal_amount'
                                        value={data.min_withdrawal_amount || ''}
                                        onChange={handleInputChange}
                                        className={`form-input-default`}
                                        placeholder="Min Withdrawal Amount"
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Max Withdrawal Amount
                                    </label>
                                    <input
                                        type="text"
                                        name='max_withdrawal_amount'
                                        value={data?.max_withdrawal_amount || ''}
                                        onChange={handleInputChange}
                                        className={`form-input-default`}
                                        placeholder="Max Withdrawal Amount"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col  md-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Min Deposit Amount
                                    </label>
                                    <input
                                        type="text"
                                        name='min_deposit_amount'
                                        value={data?.min_deposit_amount || ''}
                                        onChange={handleInputChange}
                                        className={`form-input-default`}
                                        placeholder="Min Deposit Amount"
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Max Deposit Amount
                                    </label>
                                    <input
                                        type="text"
                                        name='max_deposit_amount'
                                        value={data?.max_deposit_amount || ''}
                                        onChange={handleInputChange}
                                        className={`form-input-default`}
                                        placeholder="Max Deposit Amount"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Max Auto Add Win Amount
                                    </label>
                                    <input
                                        type="text"
                                        name='max_auto_add_win_amount'
                                        value={data?.max_auto_add_win_amount || ''}
                                        onChange={handleInputChange}
                                        className={`form-input-default`}
                                        placeholder="Max Auto Add Win Amount"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col`}>  <div className={`form-input-group`}>
                                <label htmlFor='full_name' className={`form-label`}>
                                    Activate Options
                                </label>
                                <label className={styles.switch}>
                                    <input type="checkbox" checked={isTrue || ''} onChange={handleToggle} />
                                    <span className={styles.slider}></span>
                                </label>
                            </div>
                            </div>
                        </div>
                        <button className={`btn-primary`} onClick={insertOptions}>
                            {isOptionsCreating ? <BeatLoader color='#FFFFFF' /> : `Create`}
                        </button>
                    </>
                }
            </div>
        </>
    )
}

export default Options;